import { adjustHeaderHeight } from './adjust-header-height';

function openHeader(modal, gateway) {
    modal.classList.add('show');
    gateway.classList.add('show');
    const stickyWrap = $('.sticky-wrap');

    modal.addEventListener('transitionend', function onTransitionEnd() {
        modal.style.overflow = 'visible';

        modal.removeEventListener('transitionend', onTransitionEnd);
    });

    if (stickyWrap.length) stickyWrap.addClass('expanded-header');
}

function closeHeader(modal, gateway) {
    modal.classList.remove('show');
    gateway.classList.remove('show');
    modal.style.overflow = 'hidden';
    const stickyWrap = $('.sticky-wrap');

    modal.addEventListener('transitionend', function onTransitionEnd() {
        modal.style.overflow = 'hidden';

        modal.removeEventListener('transitionend', onTransitionEnd);
    });

    if (stickyWrap.length) stickyWrap.removeClass('expanded-header');
}

function handleHeader() {
  var header = document.querySelector("header.site-header");
  var resizeObserver = new ResizeObserver(adjustHeaderHeight);

  var gateway = document.querySelector('.gateway');
  var toggleButton = document.querySelector('.gateway__toggle');
  var modal = document.getElementById('gateway-modal');

  toggleButton && toggleButton.addEventListener('click', function() {
      $('.site-country-selector .gateway__toggle-icon').toggleClass('rotate');

      if (!modal || !gateway) return;

      if (modal.classList.contains('show')) {
          closeHeader(modal, gateway)
      } else {
          openHeader(modal, gateway)
      }
  });

  adjustHeaderHeight();
  resizeObserver.observe(header);
}

function observeGatewayContent() {
  const containerSelector = '.gateway__container';
  const disclaimerSelector = '#disclaimer_block';
  const textSelector = '.mb-4.text';
  const dropdownSelector = '.dropdown__button';
  const stickyWrapSelector = '.sticky-wrap';

  function updateClasses(container, isDisclaimerVisible) {
      const textElement = container.querySelector(textSelector);
      const hasTextChildren = textElement && textElement.children.length > 0;

      if (isDisclaimerVisible && hasTextChildren) {
          container.classList.add('overlap');
      } else {
          container.classList.remove('overlap');
      }

      const stickyWrap = document.querySelector(stickyWrapSelector);
      if (stickyWrap) {
          if (isDisclaimerVisible && hasTextChildren) {
              stickyWrap.classList.add('overlapped');
          } else {
              stickyWrap.classList.remove('overlapped');
          }
      }
  }

  function updateStickyWrapClassForDropdown() {
      const stickyWrap = document.querySelector(stickyWrapSelector);
      const expandedDropdown = document.querySelector(`.gateway__container ${dropdownSelector}[aria-expanded="true"]`);
      
      if (stickyWrap) {
          if (expandedDropdown) {
              stickyWrap.classList.add('overlapped');
          } else {
              const disclaimer = document.querySelector(disclaimerSelector);
              const textElement = document.querySelector(`${containerSelector} ${textSelector}`);
              const isDisclaimerVisible = disclaimer && window.getComputedStyle(disclaimer).display !== 'none';
              const hasTextChildren = textElement && textElement.children.length > 0;
              if (!(isDisclaimerVisible && hasTextChildren)) {
                  stickyWrap.classList.remove('overlapped');
              }
          }
      }
  }

  function observeDisclaimerAndText(container) {
      const disclaimerElement = container.querySelector(disclaimerSelector);
      const textElement = container.querySelector(textSelector);
      if (!disclaimerElement || !textElement) {
          return;
      }

      function checkState() {
          const isDisclaimerVisible = window.getComputedStyle(disclaimerElement).display !== 'none';
          updateClasses(container, isDisclaimerVisible);
      }

      const disclaimerObserver = new MutationObserver(checkState);
      const textObserver = new MutationObserver(checkState);

      disclaimerObserver.observe(disclaimerElement, {
          attributes: true,
          attributeFilter: ['style']
      });

      textObserver.observe(textElement, {
          childList: true,
          subtree: true
      });

      checkState();
  }

  function observeDropdowns() {
      const dropdowns = document.querySelectorAll(dropdownSelector);
      dropdowns.forEach(dropdown => {
          const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                  if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                      updateStickyWrapClassForDropdown();
                  }
              });
          });
          observer.observe(dropdown, {
              attributes: true,
              attributeFilter: ['aria-expanded']
          });
      });

      updateStickyWrapClassForDropdown();
  }

  function findAndObserveContainers() {
      const containers = document.querySelectorAll(containerSelector);
      if (containers.length === 0) {
          setTimeout(findAndObserveContainers, 500);
          return;
      }
      containers.forEach(observeDisclaimerAndText);
      observeDropdowns();
  }

  findAndObserveContainers();
}

document.addEventListener('DOMContentLoaded', function () {
    handleHeader();
    observeGatewayContent();
});